<template>
  <div class="scroll-wrapper" data-jscroll="true">
    <FloatingForm v-if="showForm" @close="showForm = false" />
    <FloatingButton
      :class="{ 'd-none': showForm && !isLargeScreen }"
      @click="showForm = true"
    />
  </div>
</template>

<script>
import FloatingButton from "@/popup/components/FloatingButton";
import FloatingForm from "@/popup/components/FloatingForm";
import { useMediaQuery } from "@vueuse/core";
import { useStore } from "vuex";
import { SET_FACTORY } from "@/store/constants";

export default {
  name: "SellerPopup",
  components: { FloatingButton, FloatingForm },
  props: {
    industry: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    store.commit(SET_FACTORY, props.industry);
    const isLargeScreen = useMediaQuery("(min-width: 1024px)");
    return { isLargeScreen };
  },
  data() {
    return {
      showForm: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.scroll-wrapper {
  width: 100%;
  z-index: 7;
  position: fixed;
  top: 135px;
  transition: top 0.3s;

  &.scrollDown:not(.scrollTop) {
    top: 1rem;
    transition: top 0.3s;
  }
}
</style>
